//   {
//     id, // string
//     isDismissible, //boolean
//     icon, // string ("piggybank_color", etc. || fa icon)
//     title, // string
//     subtitle, // string
//     description, //string
//     buttonText, //string
//     buttonFunc, //string
//     progressBarLabel, //string
//     progressBarPercent, //string
//     customization: { // options to handle style exemptions
//     }
//   }

//   defaultCustomizations: {
//     subTitlePosition: "bottom",
//   }

export const staxSetupCards = {
  learnMore: {
    ID: 1,
    isDismissible: false,
    icon: "piggybank",
    title: "Set Up Online Giving",
    subtitle: "Included with your plan",
    description:
      "<p>Easy online giving that includes recurring donations, Text-to-Give, cover the fees, <a href='https://flocknote.com/online-church-giving/' target='_blank' rel='noopener noreferrer'> and more</a> !Verify your organization and deposit info to get started.</p> ",
    buttonText: "Get Started",
    buttonFunc: "goToInternalPage:/fundit",
    backgroundColor: "#d1d7b6",
  },
  notYetRegistered: {
    ID: 2,
    isDismissible: false,
    icon: "piggybank",
    title: "Set Up Online Giving",
    subtitle: "Included with your plan",
    description:
      "<p>Easy online giving that includes recurring donations, Text-to-Give, cover the fees, <a href='https://flocknote.com/online-church-giving/' target='_blank' rel='noopener noreferrer'>and more</a>! Verify your organization and deposit info to get started.</p>",
    buttonText: "Get Started",
    buttonFunc: "goToInternalPage:/fundit",
    backgroundColor: "#d1d7b6",
  },
  submitted: {
    ID: 3,
    isDismissible: false,
    icon: "piggybank",
    title: "Set Up Online Giving",
    subtitle: "Included with your plan",
    description:
      "<p>Thank you for submitting your information for verification. Our payment processing partner, Stax, is reviewing your information.</p>",
    backgroundColor: "#d1d7b6",
    progressBarLabel: "Your information is being reviewed",
    progressBarPercent: "50",
  },
  pended: {
    ID: 4,
    isDismissible: false,
    icon: "piggybank",
    title: "More Information Needed",
    subtitle: "Online Giving Setup",
    description:
      "<p>To enable online giving, we need more information to complete your verification.</p>",
    buttonText: "Provide Missing Info",
    buttonFunc: "openModal:STAX_KYC",
    backgroundColor: "#d1d7b6",
    progressBarLabel: "In Progress",
    progressBarPercent: "60",
  },
  // approved: {
  //   ID: 5,
  //   isDismissible: false,
  //   icon: "piggybank",
  //   title: "Set Up Online Giving",
  //   subtitle: "Included with your plan",
  //   description:
  //     "You did it! You are now ready to accept recurring donations, set up text-to-give, and more.",
  //   buttonText: "Learn More",
  //   buttonFunc: "goToExternalPage:google.com",
  //   backgroundColor: "#d1d7b6",
  // },
  rejected: {
    ID: 6,
    isDismissible: false,
    icon: "piggybank",
    title: "Set Up Online Giving",
    subtitle: "Included with your plan",
    description:
      "<p>Thank you for submitting your information for verification. Our payment processing partner, Stax, is reviewing your information.</p>",
    backgroundColor: "#d1d7b6",
    progressBarLabel: "Your information is being reviewed",
    progressBarPercent: "50",
  },
};

export const wepayMigrationCards = {
  learnMore: {
    ID: 7,
    isDismissible: false,
    icon: "piggybank",
    title: "Action Needed",
    subtitle: "",
    description:
      "<p>To continue processing payments and donations with Flocknote, you’ll need to verify your organization’s info with our new payment processor, Stax. <a href='https://help.flocknote.com/article/417-faqs-transitioning-to-our-new-payments-processor' target='_blank' rel='noopener noreferrer'>Learn more</a>.</p>",
    buttonText: "Get Started",
    buttonFunc: "openModal:STAX_KYC",
    backgroundColor: "#d1d7b6",
  },
  notYetRegistered: {
    ID: 8,
    isDismissible: false,
    icon: "piggybank",
    title: "Action Needed",
    subtitle: "",
    description:
      "<p>To continue processing payments and donations with Flocknote, you’ll need to verify your organization’s info with our new payment processor, Stax. <a href='https://help.flocknote.com/article/417-faqs-transitioning-to-our-new-payments-processor' target='_blank' rel='noopener noreferrer'>Learn more</a>.</p>",
    buttonText: "Get Started",
    buttonFunc: "openModal:STAX_KYC",
    backgroundColor: "#d1d7b6",
  },
  submitted: {
    ID: 9,
    isDismissible: false,
    icon: "piggybank",
    title: "Online Giving Verification",
    subtitle: "",
    description:
      "<p>Thank you for submitting your information for verification. Our payment processing partner, Stax, is reviewing your information. <a href='https://help.flocknote.com/article/417-faqs-transitioning-to-our-new-payments-processor#What-to-expect-after-your-verification-information-is-submitted-fL0mW' target='_blank' rel='noopener noreferrer'>Learn more</a> about what comes next.</p>",

    backgroundColor: "#d1d7b6",
    progressBarLabel: "Your information is being reviewed",
    progressBarPercent: "50",
  },
  pended: {
    ID: 10,
    isDismissible: false,
    icon: "piggybank",
    title: "More Information Needed",
    subtitle: "Transitioning from WePay to Stax",
    description:
      "<p>To continue using online giving, we need more information to complete your verification with our new payment processing partner, Stax.</p>",
    buttonText: "Provide Missing Info",
    buttonFunc: "openModal:STAX_KYC",
    backgroundColor: "#d1d7b6",
    progressBarLabel: "In Progress",
    progressBarPercent: "60",
  },
  // approved: {
  //   ID: 11,
  //   isDismissible: false,
  //   icon: "piggybank",
  //   title: "Migrate your WePay account",
  //   subtitle: "",
  //   description: "You did it! You are now ready to accept donations on Stax.",
  //   buttonText: "Learn More",
  //   buttonFunc: "goToExternalPage:google.com",
  //   backgroundColor: "#d1d7b6",
  // },
  rejected: {
    ID: 12,
    isDismissible: false,
    icon: "piggybank",
    title: "Online Giving Verification",
    subtitle: "",
    description:
      "<p>Thank you for submitting your information for verification. Our payment processing partner, Stax, is reviewing your information. <a href='https://help.flocknote.com/article/417-faqs-transitioning-to-our-new-payments-processor#What-to-expect-after-your-verification-information-is-submitted-fL0mW' target='_blank' rel='noopener noreferrer'>Learn more</a> about what comes next.</p>",
    backgroundColor: "#d1d7b6",
    progressBarLabel: "Your information is being reviewed",
    progressBarPercent: "50",
  },
};

export const flocknoteCompleteCard = {
  ID: 13,
  isDismissible: true,
  icon: "fa-users fas",
  title: "Flocknote Complete",
  subtitle: "Upgrade your plan to",
  description:
    "An all-in-one plan that includes a robust, integrated church database, advanced donor management, Family & Visitor Registration, and <a href='https://flocknote.com/people' target='_blank' rel='noopener noreferrer'>much more</a>!",
  buttonText: "Upgrade Now for $75/month",
  buttonFunc: "signupForPayments",
  backgroundColor: "#a5c8e4",
  customizations: {
    subTitlePosition: "top",
  },
};
